export default {
  title: "طلبات اشحنلي",
  subtitle: "إدارة طلبات اشحنلي",
  
  addNew: "إضافة طلب اشحنلي جديد",
  createOrder: "إنشاء طلب اشحنلي",
  editOrder: "تعديل طلب اشحنلي",
  deleteOrder: "حذف طلب اشحنلي",
  orderDetails: "تفاصيل طلب اشحنلي",
  viewOrder: "عرض طلب اشحنلي",
  printInvoice: "طباعة الفاتورة",
  
  // Tabs for details page
  tabs: {
    editOrder: "تعديل الطلب",
    statusUpdate: "تحديث الحالة",
    invoice: "الفاتورة",
    logs: "السجلات",
    summaries: "الملخصات",
    coreFormFields: "إدارة بيانات الطلب",
    statusManagement: "إدارة حالة الطلب",
    invoiceManagement: "إدارة فاتورة الطلب",
    shipmentHistory: "سجل الطلب",
    shipmentSummary: "ملخص الطلب"
  },
  
  // Fields
  fields: {
    orderNumber: "رقم الطلب",
    orderGroup: "المجموعة",
    customer: "العميل",
    merchantName: "اسم التاجر",
    description: "الوصف",
    quantity: "الكمية",
    status: "الحالة",
    netPrice: "السعر الصافي",
    servicePrice: "سعر الخدمة",
    voucherValue: "قيمة الكوبون",
    weight: "الوزن",
    width: "العرض",
    height: "الارتفاع",
    length: "الطول",
    trackingId: "رقم التتبع",
    itemPrice: "سعر المنتج",
    discount: "الخصم",
    extraService: "خدمة إضافية",
    totalPrice: "السعر الإجمالي",
    totalPaid: "المبلغ المدفوع",
    netDue: "المبلغ المستحق",
    merchantDeliveryFee: "رسوم توصيل التاجر",
    currency: "العملة",
    date: "التاريخ",
    address: "سطر العنوان الأول",
    address2: "سطر العنوان الثاني",
    phone: "الهاتف",
    carrier: "شركة الشحن",
    orderPrice: "سعر الطلب",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    originCountry: "بلد المنشأ",
    destinationCountry: "بلد الوجهة",
    shippingMethod: "طريقة الشحن",
    estimatedDelivery: "التوصيل المتوقع",
    link: "الرابط",
    itemOptions: "خيارات المنتج",
    extendedDescription: "الوصف المفصل",
    paymentType: "نوع الدفع",
    category: "الفئة",
    unitWidth: "عرض الوحدة",
    unitHeight: "ارتفاع الوحدة",
    unitLength: "طول الوحدة",
    unitWeight: "وزن الوحدة",
    itemType: "نوع المنتج",
    deliveryMode: "طريقة التوصيل",
    shippingCompany: "شركة الشحن",
    lbTransportPrice: "سعر النقل بالباوند",
    hasShippingInsurance: "يحتوي على تأمين الشحن",
    dgFees: "رسوم البضائع الخطرة",
    enableDGFees: "تفعيل رسوم البضائع الخطرة",
    city: "المدينة",
    localDeliveryFee: "رسوم التوصيل المحلي",
    shippingOrderNumber: "رقم طلب الشحن",
    refundInvoiceNumber: "رقم فاتورة الاسترداد",
    reorderedId: "معرف إعادة الطلب",
    refundType: "نوع الاسترداد",
    additionalCost: "التكلفة الإضافية",
    initialPartialPayment: "الدفع الجزئي الأولي",
    orderStatus: "حالة الطلب",
    comment: "التعليق",
    currentStatus: "الحالة الحالية",
    paymentStatus: "حالة الدفع",
    paymentMethod: "طريقة الدفع",
    shippingCompanyPricePerLB: "سعر شركة الشحن لكل رطل",
    enableLBPrice: "تفعيل سعر الرطل",
    shippingInsurance: "تأمين الشحن",
    refundCode: "رمز الاسترداد",
    refundReceipt: "إيصال الاسترداد",
    trackingNumber: "رقم التتبع",
    flightNumber: "رقم الشحنة",
    customsReference: "مرجع الجمارك",
    courierName: "اسم الناقل",
    refundReference: "مرجع الاسترداد",
    lengthMeasurementUnit: "وحدة الطول",
    weightMeasurementUnit: "وحدة الوزن"
  },
  
  // Placeholders
  placeholders: {
    searchOrders: "البحث في طلبات اشحنلي...",
    selectCustomer: "اختر العميل",
    enterMerchantName: "أدخل اسم التاجر",
    enterDescription: "تفضيلات أو تعليمات الطلب مثل اللون،الحجم،كوبون خصم",
    enterQuantity: "أدخل الكمية",
    enterWeight: "أدخل الوزن (باوند)",
    enterWidth: "أدخل العرض (بوصة)",
    enterHeight: "أدخل الارتفاع (بوصة)",
    enterLength: "أدخل الطول (بوصة)",
    enterTrackingId: "أدخل رقم التتبع",
    selectOriginCountry: "اختر بلد المنشأ",
    selectDestinationCountry: "اختر بلد الوجهة",
    selectShippingMethod: "اختر طريقة الشحن",
    enterLink: "أدخل رابط المنتج",
    enterExtendedDescription: "أدخل الوصف المفصل",
    selectPaymentType: "اختر نوع الدفع",
    selectCategory: "اختر الفئة",
    selectShippingCompany: "اختر شركة الشحن",
    enterLbPrice: "أدخل السعر لكل باوند",
    enterComment: "أدخل التعليق",
    enterItemPrice: "أدخل سعر المنتج",
    selectCurrency: "اختر العملة",
    selectPaymentMethod: "اختر طريقة الدفع",
    enterMerchantDeliveryFee: "أدخل رسوم توصيل التاجر",
    enterPricePerLB: "أدخل السعر لكل باوند",
    enterDgFees: "أدخل رسوم البضائع الخطرة",
    selectCity: "اختر المدينة",
    enterLocalDeliveryFee: "أدخل رسوم التوصيل المحلي",
    selectLengthUnit: "اختر وحدة الطول",
    selectWeightUnit: "اختر وحدة الوزن",
    enterInitialPartialPayment: "أدخل مبلغ الدفع الجزئي الأولي",
    enterAdditionalCost: "أدخل التكلفة الإضافية"
  },
  
  // Status options (same as orders but with Ship4Me context)
  statusOptions: {
    0: "في الانتظار",
    1: "تم التحقق",
    2: "مرفوض",
    3: "صالح للشحن",
    4: "مرفوض من الشحن",
    5: "تم التسعير",
    6: "موافق عليه",
    7: "موافق عليه من العميل",
    8: "مرفوض من العميل",
    9: "الدفع قيد التحصيل",
    10: "جاري شراء الطلب",
    11: "معلق",
    12: "ملغي",
    13: "تم شراء الطلب",
    14: "في الطريق لمستودع المصدر",
    15: "تم الاستلام في مستودع المصدر",
    16: "مفقود/تالف",
    17: "متأخر",
    18: "مسترد",
    19: "إعادة طلب",
    20: "تم الشحن",
    21: "الطلب وصل بلد العميل",
    22: "تحت التخليص الجمركي",
    23: "تم الإفراج من الجمارك",
    24: "جاري توصيل الطلب للعميل",
    25: "تم التوصيل",
    26: "فشل التوصيل",
    27: "جاري توصيل الطلب (إعادة جدولة)",
    28: "إرجاع الطلب للمرسل",
    29: "ملغي من التاجر",
    30: "الاسترداد قيد المعالجة",
    31: "في انتظار استلام الشحنة",
    unknown: "حالة غير معروفة"
  },

  // Payment type options
  paymentTypes: {
    0: "الدفع عند الاستلام",
    1: "الدفع الجزئي",
    2: "الدفع المسبق"
  },

  // Item type options
  itemTypes: {
    0: "عادي",
    1: "خطرة"
  },

  // Delivery mode options
  deliveryModes: {
    0: "اقتصادي",
    1: "سريع"
  },

  // Refund type options
  refundTypes: {
    0: "يرجى الاختيار",
    1: "نقدي",
    2: "كوبون"
  },

  // Extra field labels
  extraFieldLabels: {
    courierReceiptNo: "رقم إيصال المندوب",
    orderNumber: "رقم الطلب",
    shippingOrderNo: "رقم طلب الشحن",
    reorderNumber: "رقم إعادة الطلب",
    refundReceiptNo: "رقم إيصال الاسترداد"
  },

  // Messages
  messages: {
    createSuccess: "تم إنشاء الطلب بنجاح",
    createError: "فشل في إنشاء الطلب",
    updateSuccess: "تم تحديث الطلب بنجاح",
    updateError: "فشل في تحديث الطلب ",
    deleteSuccess: "تم حذف الطلب بنجاح",
    deleteError: "فشل في حذف الطلب",
    deleteConfirm: "هل أنت متأكد من حذف هذا الطلب؟",
    statusUpdateSuccess: "تم تحديث حالة الطلب بنجاح",
    statusUpdateError: "فشل في تحديث حالة الطلب",
    noOrders: "لا توجد طلبات",
    loadingOrders: "جاري تحميل الطلبات ...",
    loading: "جاري تحميل تفاصيل الطلب...",
    fetchError: "فشل في جلب الطلبات",
    orderNotFound: "الطلب غير موجود",
    noInvoices: "لا توجد فواتير.",
    noLogs: "لا توجد سجلات.",
    rejectedShipping: "تم رفض الطلب بسبب موانع الشحن",
    rejected: "تم رفض الطلب",
    somethingWentWrong: "حدث خطأ ما",
    failedToUpdate: "فشل في تحديث الطلب",
    failedToUpdateStatus: "فشل في تحديث حالة الطلب",
    orderUpdatedSuccessfully: "تم تحديث الطلب بنجاح!",
    orderUpdated: "تم تحديث الطلب بنجاح",
    updateFailed: "فشل في تحديث الطلب",
    orderCalculated: "تم حساب الطلب بنجاح",
    calculationFailed: "فشل في حساب الطلب",
    orderReset: "تم إعادة تعيين الطلب بنجاح",
    resetFailed: "فشل في إعادة تعيين الطلب",
    statusUpdated: "تم تحديث الحالة بنجاح",
    statusUpdateFailed: "فشل في تحديث الحالة"
  },
  
  // Actions
  actions: {
    view: "عرض",
    edit: "تعديل",
    delete: "حذف",
    print: "طباعة",
    updateStatus: "تحديث الحالة",
    back: "العودة لطلبات شحن لي",
    save: "حفظ التغييرات",
    cancel: "إلغاء",
    refresh: "تحديث",
    calculateShipping: "حاسبة الطلب",
    requestQuote: "طلب عرض سعر",
    updating: "جاري التحديث...",
    saveStatus: "حفظ الحالة",
    addNewInvoice: "إضافة فاتورة جديدة",
    validateOrder: "التحقق من الطلب",
    invalidateOrder: "إلغاء/رفض الطلب",
    updateOrder: "تحديث الطلب",
    calculating: "جاري الحساب...",
    calculateOrder: "حساب الطلب",
    calculate: "حاسبة الشحن",
    resetOrder: "إعادة تعيين الطلب",
    confirm: "تأكيد",
    virtualPartialCalculation: "حساب الدفع الجزئي الافتراضي",
    partialPaymentValidationCalculation: "التحقق والحساب للدفع الجزئي",
    applying: "جاري التطبيق...",
    processing: "جاري المعالجة...",
    apply: "تطبيق"
  },

  calculator: {
    title: "حاسبة الشحن لـ Ship4Me",
    subtitle: "احسب تكاليف الشحن لطلبات Ship4Me بدون حفظ في قاعدة البيانات"
  },

  form: {
    merchantDeliveryFee: "رسوم التوصيل من التاجر"
  },

  // Table headers
  table: {
    orderNumber: "رقم الطلب",
    group: "المجموعة",
    customer: "العميل",
    merchantName: "التاجر",
    quantity: "الكمية",
    status: "الحالة",
    netPrice: "السعر الصافي",
    actions: "خيارات الأوامر",
    originCountry: "المصدر",
    destinationCountry: "الوجهة",
    shippingMethod: "الطريقة",
    no: "الرقم",
    amountFC: "المبلغ بالعملة الأجنبية",
    amountIQD: "المبلغ بالدينار العراقي",
    collectionDate: "تاريخ التحصيل",
    collected: "حالة التحصيل",
    received: "حالة الاستلام",
    courierReceiptNo: "رقم إيصال المندوب",
    paymentGateway: "بوابة الدفع",
    user: "المستخدم",
    actionDate: "تاريخ الإجراء",
    log: "السجل"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    shipforme: "طلبات اشحنلي",
    create: "إنشاء طلب اشحنلي",
    edit: "تعديل طلب اشحنلي",
    view: "تفاصيل طلب اشحنلي"
  },
  
  // Sections
  sections: {
    merchantDetails: "تفاصيل التاجر",
    orderInfo: "معلومات الطلب",
    dimensions: "الأبعاد",
    shippingTracking: "الشحن والتتبع",
    pricing: "تفاصيل التسعير",
    customerInfo: "معلومات العميل",
    orderHistory: "تاريخ الطلب",
    statusHistory: "تاريخ الحالة",
    shippingDetails: "تفاصيل الشحن",
    packageInfo: "معلومات الطرد",
    basicInformation: "المعلومات الأساسية",
    locationAndCategory: "الموقع والتصنيف",
    refundDetails: "تفاصيل الاسترداد",
    productInformation: "معلومات المنتج",
    pricingQuantity: "التسعير والكمية",
    locationShipping: "الموقع والشحن",
    dimensionsWeight: "الأبعاد والوزن",
    shippingOptions: "خيارات الشحن",
    extraInformation: "معلومات إضافية"
  },
  
  // Units
  units: {
    lb: "باوند",
    inch: "بوصة",
    usd: "دولار",
    iqd: "دينار",
    kg: "كيلوغرام",
    cm: "سنتيمتر"
  },
  
  // Validation
  validation: {
    linkRequired: "الرابط مطلوب",
    linkInvalid: "يرجى إدخال رابط صحيح",
    merchantNameRequired: "اسم التاجر مطلوب",
    merchantNameMinLength: "اسم التاجر يجب أن يكون على الأقل حرفين",
    descriptionRequired: "وصف المنتج مطلوب",
    descriptionMinLength: "الوصف يجب أن يكون على الأقل 3 أحرف",
    quantityRequired: "الكمية يجب أن تكون أكبر من 0",
    quantityMin: "الكمية يجب أن تكون على الأقل 1",
    quantityMax: "الكمية لا يمكن أن تتجاوز 1000",
    itemPriceRequired: "سعر المنتج يجب أن يكون أكبر من 0",
    itemPriceMax: "سعر المنتج مرتفع جداً",
    currencyRequired: "يرجى اختيار العملة",
    weightRequired: "الوزن يجب أن يكون أكبر من 0",
    weightMax: "الوزن لا يمكن أن يتجاوز 1000 كيلوغرام",
    widthRequired: "العرض يجب أن يكون أكبر من 0",
    widthMax: "العرض لا يمكن أن يتجاوز 1000 سم",
    heightRequired: "الارتفاع يجب أن يكون أكبر من 0",
    heightMax: "الارتفاع لا يمكن أن يتجاوز 1000 سم",
    lengthRequired: "الطول يجب أن يكون أكبر من 0",
    lengthMax: "الطول لا يمكن أن يتجاوز 1000 سم",
    dimensionsRequired: "الأبعاد مطلوبة",
    originCountryRequired: "يرجى اختيار بلد المصدر",
    destinationCountryRequired: "يرجى اختيار بلد الوجهة",
    categoryRequired: "يرجى اختيار التصنيف",
    shippingCompanyRequired: "يرجى اختيار شركة الشحن",
    pricePerLBRequired: "سعر الباوند مطلوب عند التفعيل",
    shippingMethodRequired: "طريقة الشحن مطلوبة",
    paymentTypeRequired: "يرجى اختيار نوع الدفع",
    allFieldsRequired: "جميع الحقول مطلوبة"
  },
  
  // Shipping methods
  shippingMethods: {
    air: "الشحن الجوي",
    sea: "الشحن البحري",
    land: "النقل البري",
    express: "التوصيل السريع",
    economy: "الشحن الاقتصادي",
    standard: "الشحن العادي"
  },

  // Summary section
  summary: {
    exchangePrice: "سعر الصرف",
    choosenWeight: "الوزن المختار",
    shippingCost: "تكلفة الشحن",
    shippingInsurance: "تأمين الشحن",
    fuelCost: "تكلفة الوقود",
    tax: "الضريبة",
    shipForMeCost: "تكلفة اشحنلي",
    additionalCost: "التكلفة الإضافية",
    totals: "المجموع",
    discount: "الخصم",
    servicePrice: "سعر الخدمة",
    netPrice: "السعر الصافي",
    locked: "مقفل",
    fxLockTitle: "سعر الصرف المقفل (عند الدفع)",
    lockedRate: "سعر الدولار/الدينار",
    rateSource: "مصدر السعر",
    lockedAt: "وقت القفل",
    roundingRule: "قاعدة التقريب"
  },

  // Modal translations
  modal: {
    compareChanges: "مقارنة التغييرات",
    previous: "السابق",
    current: "الحالي",
    confirmStatusChange: "تأكيد تغيير الحالة",
    confirmPendingMessage: "هل أنت متأكد من أنك تريد تعيين حالة هذا الطلب إلى",
    confirmStatusChangeMessage: "هل أنت متأكد من أنك تريد تغيير الحالة؟",
    pending: "قيد الانتظار",
    yesChange: "نعم، غيّر"
  },

  // Voucher approval translations
  voucherApproval: {
    title: "مطلوب موافقة على استرداد الكوبون",
    message: "هل تؤكد إرسال كوبون للعميل بمبلغ",
    approve: "نعم، أرسل الكوبون",
    cancel: "إلغاء",
    partialPaymentNote: "هذا المبلغ يمثل الدفعة الجزئية الأولى التي دفعها العميل."
  },
  common: {
    notCollected: "لم يتم التحصيل",
    collected: "تم التحصيل",
    received: "تم الاستلام",
    notReceived: "لم يتم الاستلام",
    no: "لا",
    yes: "نعم"
  },

  // Customer Actions (Admin performing actions on behalf of customer)
  customerActions: {
    title: "إجراءات العميل (المسؤول)",
    description: "هذا الطلب في انتظار موافقة العميل. يمكنك تنفيذ هذه الإجراءات نيابة عن العميل.",
    applyVoucher: "تطبيق كوبون",
    voucherCode: "رمز الكوبون",
    enterVoucherCode: "أدخل رمز الكوبون",
    voucherRequired: "يرجى إدخال رمز الكوبون",
    voucherApplied: "تم تطبيق الكوبون بنجاح",
    voucherAppliedAmount: "الكوبون المطبق",
    voucherFailed: "فشل في تطبيق الكوبون",
    approveReject: "الموافقة أو رفض الطلب",
    approveRejectDescription: "انقر على أحد الأزرار أدناه للموافقة على هذا الطلب أو رفضه نيابة عن العميل.",
    approve: "الموافقة على الطلب",
    reject: "رفض الطلب",
    orderApproved: "تمت الموافقة على الطلب نيابة عن العميل",
    orderRejected: "تم رفض الطلب نيابة عن العميل",
    statusChangeFailed: "فشل في تغيير الحالة"
  }
};
